import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Portfolio from "./pages/Portfolio";
import PasswordGate from "./components/PasswordGate";

function App() {
  return (
    <div className="App">
      <PasswordGate>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Portfolio />} />
          </Routes>
        </BrowserRouter>
      </PasswordGate>
    </div>
  );
}

export default App;
